import React, { useEffect, useState, useCallback, Fragment, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fromStore } from '../../selectors';
import { setHandbookPaging, fetchWebhooks } from '../../action/handbook';
import Loader from '../utils/Loader';
import TableWebhooks from './TableWebhooks';
import Portlet from '../utils/Portlet';
import ReactPaginate from 'react-paginate';
import ErrorContainer from '../utils/ErrorContainer';

const WebhooksList = () => {
    const dispatch = useDispatch();

    const { paging, count, role } = useSelector(state => ({
        paging: state.handbook.paging.webhooks,
        count: state.handbook.count.webhooks,
        role: state.user.info.role.id,
    }));

    const webhooks = useSelector(fromStore.webhooksListSelector);
    const loading = useSelector(fromStore.loaderWebhooksSelector);

    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        dispatch(fetchWebhooks());
    }, [dispatch]);

    const setPageLimit = useCallback((e) => {
        e.preventDefault();
        const limit = Number(e.target.value);
        const updatedPaging = { start: 0, limit };
        setCurrentPage(0);
        dispatch(setHandbookPaging('webhooks', updatedPaging));
        dispatch(fetchWebhooks());
    }, [dispatch]);

    const handlePageClick = useCallback((data) => {
        const nextStart = data.selected * paging.limit;
        const updatedPaging = { ...paging, start: nextStart };
        setCurrentPage(data.selected);
        dispatch(setHandbookPaging('webhooks', updatedPaging));
        dispatch(fetchWebhooks());
    }, [dispatch, paging]);

    const paginationComponent = useMemo(() => {
        if (webhooks.length === 0) return null;
        
        const pages = Math.ceil(count / paging.limit);
        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={8}
                    pageRangeDisplayed={5}
                    forcePage={currentPage}
                    onPageChange={handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />
                <div className="kt-datatable__pager-info">
                    <div className="kt-datatable__pager-size">
                        <select onChange={setPageLimit} value={paging.limit} className="form-control">
                            {[10, 20, 30, 50, 100].map(size => (
                                <option key={size} value={size}>{size}</option>
                            ))}
                        </select>
                    </div>
                    <span className="kt-datatable__pager-detail">
                        Показано {paging.start + 1} - {Math.min(paging.start + paging.limit, count)} из {count}
                    </span>
                </div>
            </div>
        );
    }, [webhooks.length, count, currentPage, handlePageClick, paging, setPageLimit]);

    const content = useMemo(() => {
        if (loading) {
            return <div className="kt-datatable__loading"><Loader /></div>;
        }
        
        return (
            <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                <TableWebhooks role={role} items={webhooks} />
                {paginationComponent}
            </div>
        );
    }, [loading, webhooks, paginationComponent, role]);

    return (
        <Fragment>
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Вебхуки</h3>
                    </div>
                </div>
            </div>
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <Portlet fit={true}>
                    <ErrorContainer field="webhooks" style={{ margin: 15 }} hasCloseButton={true} />
                    {content}
                </Portlet>
            </div>
        </Fragment>
    );
};

export default WebhooksList;

